import initAxios from "./initAxios";
import getEnvironDomainHost from "../utils/getEnvironDomainHost";

class SecuritySurveyApi {
  constructor() {
    const host = getEnvironDomainHost();
    this.axios = initAxios({ baseURL: host, withCredentials: true });
  }

  getIsParticipant = () => this.axios.get("/webapi/enabler/v1/survey/security");

  sendPoint = (data) =>
    this.axios.post("/webapi/enabler/v1/survey/security", data);

  sendAnswer = (data) =>
    this.axios.post("/webapi/enabler/v1/survey/security/comment", data);
}

export default SecuritySurveyApi;
